import styled from 'styled-components';

export const Map = styled.div.attrs({
  className: 'mappolino'
})`
  width: ${props => props.data.width}px;
  height: ${props => props.data.height}px;
  background-size: contain;
  background: white url(${props => props.data.backgroundImage}) no-repeat;
`;

export default Map;
